import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Question } from "@phosphor-icons/react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);

  const jsonLd = {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };

  return (
    <>
      <SEO title="Frequently Asked Questions" description="Answers to common questions about buying electric bikes, delivery, warranty, servicing, finance and returns at Ebikes&Gear." path="/faq" jsonLd={faqs.length ? jsonLd : null} />
      <PageHero title="Frequently asked questions" subtitle="Everything you need to know about buying, owning and maintaining your electric bike." image="https://images.unsplash.com/photo-1571068316344-75bc76f77890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" crumbs={[{ label: "FAQ" }]} />

      <section className="container-px py-16">
        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`f${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left text-lg font-bold"><span className="flex items-center gap-3"><Question size={20} className="text-primary shrink-0" /> {f.q}</span></AccordionTrigger>
                <AccordionContent className="pl-9 text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 rounded-3xl border border-border bg-card p-8 text-center">
            <h3 className="text-xl font-black">Still have questions?</h3>
            <p className="mt-2 text-muted-foreground">Our friendly team is here to help you ride away happy.</p>
            <Link to="/contact" className="btn-primary mt-5">Contact us <ArrowRight size={18} /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
